/**
 * Shared UI utility functions for GLYDE Voice SDK components
 * @packageDocumentation
 */

/**
 * Convert a numeric or string value to a CSS value string.
 * Numbers are treated as pixel values; strings are passed through.
 * @param value - Number (px) or string CSS value
 * @returns CSS value string, or undefined if input is undefined
 */
export function toCssValue(value: number | string | undefined): string | undefined {
  if (value === undefined) return undefined;
  return typeof value === 'number' ? `${value}px` : value;
}
